import { action, observable } from 'mobx';

import { RootStore } from 'stores/rootStore';
import { AmountValue, ChartPeriods } from 'common/interfaces';

import { API_ASSET_CHART } from 'api/endpoints';

interface ChartData {
  date: string;
  value: AmountValue;
}

interface AllChartsData {
  [key: string]: ChartData[];
}


export class AssetChartStore {
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable chartsData: AllChartsData = {};

  getData = async (isin: string) => {
    if (!this.chartsData[isin]) {
      await this.fetchData(isin);
    }
  };

  @action
  fetchData = async (woodId: string) => {
    const period = ChartPeriods.LAST_5Y;
    const URL = API_ASSET_CHART(woodId, period);

    const response = await this.rootStore.stores.apiStore.get<ChartData[]>(
      URL,
      [400,404],
    );
    if (response?.data) {
      this.chartsData[woodId] = response.data;
    } else {
      this.chartsData[woodId] = [];
    }
  };
}
